import dayjs from "dayjs"
import { useMemo } from "react"
import {
  useEntryLoading,
  useEntryLoadingDetails,
  useEventLoading,
  useEventLoadingDetails,
} from "src/contexts/LoadingContexts"
import { useThisMinute } from "src/hooks"

/*
 * show loading indicator when:
 * - we haven't loaded any data yet
 * - we will load data and haven't yet
 * - we are loading data and haven't loaded the last 15 minutes of data yet
 */
export function useIsLoadingRecentGlucoseData() {
  const thisMinute = useThisMinute()

  const eventLoading = useEventLoading()
  const entryLoading = useEntryLoading()
  const eventLoadingDetails = useEventLoadingDetails()
  const entryLoadingDetails = useEntryLoadingDetails()

  const loadUntilTime = useMemo(
    () => dayjs(thisMinute).subtract(
      15,
      "minutes",
    )
      .toISOString(),
    [thisMinute],
  )

  const isLoadingEvents = eventLoading.loading
    ? eventLoadingDetails.loadedAfter === null ||
      eventLoadingDetails.loadedAfter > loadUntilTime
    : eventLoading.error === null && eventLoading.willLoad

  const isLoadingEntries = entryLoading.loading
    ? entryLoadingDetails.loadedAfter === null ||
      entryLoadingDetails.loadedAfter > loadUntilTime
    : entryLoading.error === null && entryLoading.willLoad

  return isLoadingEvents || isLoadingEntries
}
